<template>
  <el-form class="file-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="oneFlag">
      <template slot="label">
        数量
      </template>
      <el-radio-group v-model="control.oneFlag">
        <el-radio :label="true">一条</el-radio>
        <el-radio :label="false">多条</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item prop="kinds">
      <template slot="label">
        类型
      </template>
      <el-radio-group v-model="hasFileType" @change="changeKinds">
        <el-radio :label="true">不限</el-radio>
        <el-radio :label="false">自定义</el-radio>
      </el-radio-group>
      <el-select
        v-if="!hasFileType"
        v-model="control.fileType"
        multiple
        filterable
        clearable
        allow-create
        default-first-option
        placeholder="请输入"
        no-data-text="请输入后再选择"
        class="main-value"
      >
        <el-option
          v-for="item in fileTypeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="displayType">
      <template slot="label">
        显示样式
      </template>
      <div>
        <el-select v-model="control.displayType">
          <el-option label="列表" value="list"></el-option>
          <el-option label="卡片" value="card"></el-option>
        </el-select>
      </div>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        提示
      </template>
      <el-input v-model="control.hint"></el-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="app">
      <template slot="label">
        移动端
      </template>
      <div class="app-setting">
        <el-checkbox v-model="control.compress">自动压缩</el-checkbox>
        <el-checkbox v-model="control.onlyCamera">仅拍照上传</el-checkbox>
        <el-checkbox v-model="hasWaterMark" @change="changeWaterMark">
          设置图片水印
        </el-checkbox>
      </div>
      <tree-select
        v-if="hasWaterMark"
        v-model="control.watermark"
        :group-list="waterMarkInfos"
        multiple
      ></tree-select>
    </el-form-item>
    <el-form-item prop="addWaterMark">
      <template slot="label">
        下载
      </template>
      <div class="water-mark-setting">
        <el-checkbox v-model="control.aw">添加水印</el-checkbox>
      </div>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import TreeSelect from "@/components/UIComponents/TreeSelect"
import { waterMarkInfos } from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"

export default {
  name: "file-control",
  components: { TreeSelect },
  props: {
    control: Object,
    sheet: Object,
    availableSheets: Array
  },
  data() {
    return {
      waterMarkInfos,
      hasFileType: false,
      hasWaterMark: false
    }
  },
  computed: {
    fileTypeOptions() {
      return this.control.fileType.map(kind => ({ label: kind, value: kind }))
    }
  },
  created() {
    this.hasFileType = !this.control.fileType.length
    this.hasWaterMark = !!this.control.watermark.length
    this.control.displayType = this.control.displayType ? this.control.displayType : "list"
  },
  methods: {
    changeKinds(val) {
      this.control.fileType = []
    },
    changeWaterMark(val) {
      this.control.watermark = []
    }
  }
}
</script>

<style lang="scss" scoped>
.file-control {
  .app-setting {
    display: flex;
    flex-flow: column;
  }
  .el-select {
    width: 100%;
  }
}
</style>
